// extracted by mini-css-extract-plugin
module.exports = {"List":"ProductLinkList_List__03X2a"};